module.exports = __webpack_public_path__ + "img/arrow-down.a68f6197.svg";